import { z } from "zod";
import { dmaSpaceDtoSchema } from "./dma-space.schema";
export const dmaReactionParticipantDtoSchema = z.object({
    compoundId: z.number(),
    moles: z.number(),
    space: dmaSpaceDtoSchema,
});
